export const GRAPH_SCOPES =
  "openid profile email offline_access User.Read Mail.ReadWrite Mail.Send Calendars.ReadWrite OnlineMeetings.ReadWrite ChannelMessage.Send Chat.ReadWrite Team.ReadBasic.All Channel.ReadBasic.All Mail.Read.Shared";
